(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dia-del-padre"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initCarousels(root){
    (root || document).querySelectorAll('.dp-product-carousel').forEach(function(track){
      if(track.dataset.dpInit){ return; }
      track.dataset.dpInit = '1';
      var nav = track.parentNode.querySelector('.dp-carousel-nav');
      if(!nav){ return; }
      var dotsWrap = nav.querySelector('.dp-dots');
      var cards = Array.prototype.slice.call(track.querySelectorAll('.dp-card'));
      dotsWrap.innerHTML = '';
      cards.forEach(function(card, i){
        var b = document.createElement('button');
        b.className = 'dp-dot';
        b.setAttribute('type','button');
        b.setAttribute('aria-label','Ir al producto ' + (i + 1));
        b.addEventListener('click', function(){
          track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.appendChild(b);
      });
      var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.dp-dot'));
      function setActive(){
        var idx = 0, min = Infinity;
        cards.forEach(function(card, i){
          var d = Math.abs(card.offsetLeft - track.scrollLeft - track.offsetLeft);
          if(d < min){ min = d; idx = i; }
        });
        dots.forEach(function(d, i){ d.classList.toggle('is-active', i === idx); });
      }
      track.addEventListener('scroll', function(){ window.requestAnimationFrame(setActive); }, { passive: true });
      nav.querySelector('.dp-prev').addEventListener('click', function(){ track.scrollBy({ left: -track.clientWidth * 0.75, behavior: 'smooth' }); });
      nav.querySelector('.dp-next').addEventListener('click', function(){ track.scrollBy({ left:  track.clientWidth * 0.75, behavior: 'smooth' }); });
      setActive();
    });
  }
  function initReveal(root){
    var items = (root || document).querySelectorAll('.dp-reveal');
    if(!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      items.forEach(function(el){ el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.14 });
    items.forEach(function(el){ io.observe(el); });
  }
  document.addEventListener('DOMContentLoaded', function(){ initCarousels(); initReveal(); });
  // Soporte para el editor de temas (al recargar la sección)
  document.addEventListener('shopify:section:load', function(e){ initCarousels(e.target); initReveal(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-fixed"]) return;
  try {
    
  function initPromoFixed(){
    var $ttpromofixed = $(".tt-promo-fixed"),
    	$promofixeddata = $(".promofixeddata"),
        $promofixedclose = $ttpromofixed.find(".tt-btn-close");
    
    if($('html').hasClass('touch-device') && $ttpromofixed.hasClass('hidden-mobile')) return false;
	if($ttpromofixed.hasClass('hidden-mobile') && $(window).width < 1025) return false;
    if($promofixeddata.length == 0) return false;
    
    setPromoFixedItem($ttpromofixed, $promofixeddata);
	showPromoFixed($ttpromofixed, $ttpromofixed.data('start'));
    
	showPromoFixedNextMessage($ttpromofixed, $promofixeddata, $promofixedclose)

    $promofixedclose.click(function(){
      $ttpromofixed.addClass('nonevent').fadeTo(100, 0);
    });
  }
  function showPromoFixedNextMessage($modal, $data, $close){
    var nextmin = $modal.data('min'),
        nextmax = $modal.data('max');
	var i = getRndInteger(nextmin, nextmax);
    setTimeout(function(){
      $close.trigger('click');
      setTimeout(function(){
        setPromoFixedItem($modal, $data);
        showPromoFixed($modal, 0);
        showPromoFixedNextMessage($modal, $data, $close);
      }, 100);
    }, i);
  }
  function getPromoFixedCustomProductIndex($promofixeddata){
    var min = 0,
        max = $promofixeddata.children().length;
    return getRndInteger(min, max);
  }
  function setPromoFixedItem($modal, $data){
    var i = getPromoFixedCustomProductIndex($data)
    var data = $data.children().eq(i);
    $modal.find('.tt-img').find('a').attr('href', data.data('url')).find('img').attr('src', data.data('image')).attr('alt', data.data('alt'));
    $modal.find('.pr_name').attr('href', data.data('url')).text(data.data('name'));
    
    var nummin = parseInt(data.data('min')),
    	nummax = parseInt(data.data('max')),
    	num = getRndInteger(nummin, nummax);
    $modal.find('.tt-info-value').text(num);

	if (typeof data.data('text') === typeof undefined) return false;
    var str = data.data('text').split('||'),
    	i = getRndInteger(0, str.length-1);
    $modal.find('.tt-info-text').text(str[i]);
  }
  function showPromoFixed($parent, delay){
    setTimeout(function(){
	  $parent.removeClass('nonevent').fadeTo(300, 1);
    }, delay);
  }
  function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
  }
  setTimeout(initPromoFixed, 300);

  } catch(e) { console.error(e); }
})();
})();
